import { colors } from '@packages/core/styles';
import { Typography } from '@packages/ui/shared';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';

import { LEGEND_STATUSES } from '../helpers/diagram-modules';
import { ssm5TextStyles } from '../ssm5.styles';
import { Ssm5ModuleStatusChip } from './ssm5-module-status-chip';

const useStyles = createUseStyles({
    // The design's row: 52px high, a 16/24 inset, the chips 16px apart, a border under it.
    legend: {
        alignItems: 'center',
        backgroundColor: colors.white,
        borderBottom: `1px solid ${colors.grayThree}`,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 16,
        padding: '16px 24px',
    },
});

/**
 * The "Module Status" row over the CAN Bus diagram: one chip per status a module cell can show, on a
 * white row closed by a border, as the design draws it.
 *
 * @returns the legend
 */
export function Ssm5ModuleStatusLegend() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.legend}>
            <Typography style={ssm5TextStyles.legendTitle} variant="default">
                {t('ssm5:diagram.legend.title')}
            </Typography>
            {LEGEND_STATUSES.map((status) => (
                <Ssm5ModuleStatusChip key={status} status={status} />
            ))}
        </div>
    );
}
